import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Skeleton shown while a lazy-loaded chart chunk is downloading.
 * Matches the ChartCard height to prevent layout shift.
 */
export default function ChartSkeleton({ title }) {
  return (
    <Card className="border-slate-200" data-testid="chart-skeleton">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-sm font-semibold text-slate-400 flex items-center gap-2">
          {title || "Loading chart..."}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-2">
        <div className="h-[220px] w-full rounded bg-slate-100 animate-pulse" />
      </CardContent>
    </Card>
  );
}
